module.exports = __webpack_public_path__ + "static/media/icn_close_big_dark.2088bbbd.svg";